import { render, staticRenderFns } from "./el-menu-tree.vue?vue&type=template&id=248a0d65&scoped=true&"
import script from "./el-menu-tree.vue?vue&type=script&lang=js&"
export * from "./el-menu-tree.vue?vue&type=script&lang=js&"
import style0 from "./el-menu-tree.vue?vue&type=style&index=0&id=248a0d65&scoped=true&lang=css&"
import style1 from "./el-menu-tree.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248a0d65",
  null
  
)

component.options.__file = "el-menu-tree.vue"
export default component.exports